var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link"},[_c('span',{staticClass:"no-icon",on:{"click":_vm.signOut}},[_vm._v("LOG OUT")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }